<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<br/><br/><br/><br/><br/><br/><br/>
<p><em>After exiting a twelve-year marriage, I set out to explore the world of online dating. I gave myself twelve months to have fun, learn, and not fall in love. After over 100 dates, these are my honest thoughts and experiences of what has been a fascinating personal journey.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2dcd6f0a